import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bcced58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-border-b-[0.5px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] tw-flex tw-items-center tw-justify-between tw-pl-[65px] tw-pr-[25px] tw-text-[12px] tw-font-medium tw-py-3 tw-gap-2" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-justify-center tw-gap-[100px]" }
const _hoisted_3 = {
  key: 1,
  class: "tw-w-[11px]"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "tw-w-full tw-my-0 tw-border-[#eff0f1]" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "tw-w-full tw-text-[10px]"
}

import { ref } from "vue";
import ArrowDownTableIcon from "../svgs/arrowDownTableIcon.vue";
import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'manageTemplateCatergoryItem',
  props: {
  data: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: false,
    default: 0,
  },
  noIndex: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: [],
  setup(__props, { emit }) {

const props = __props;



const idItemExpland: any = ref(null);



return (_ctx: any,_cache: any) => {
  const _component_ManageTemplateCatergoryItem = _resolveComponent("ManageTemplateCatergoryItem", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", {
        class: _normalizeClass(`${!__props.data.headingDetails ? 'tw-text-[10px]' : ''} ${
        __props.noIndex ? 'tw-pl-[30px]' : ''
      } tw-m-0`),
        style: _normalizeStyle(`padding-left: ${__props.data.level * 30}px`)
      }, _toDisplayString(__props.noIndex ? "" : __props.index + 1 + ".") + " " + _toDisplayString(__props.data.categoryName ||
        (__props.data.headingLabel
          ? __props.data.headingLabel
          : _unref(getComponentUiText)(
              "app-component-assessments-input-question-other-1",
            ))), 7),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["tw-w-[20px] tw-flex tw-items-center tw-justify-center tw-text-[#878787]", __props.data.headingItemCount ? 'tw-text-[10px]' : ''])
        }, _toDisplayString(__props.data.categoryCount || __props.data.headingItemCount), 3),
        (__props.data.headingDetails)
          ? (_openBlock(), _createBlock(ArrowDownTableIcon, {
              key: 0,
              color: '#ccc',
              class: _normalizeClass([__props.data.id === idItemExpland.value ? 'show' : '', 'tw-cursor-pointer']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (idItemExpland.value = idItemExpland.value === __props.data.id ? null : __props.data.id))
            }, null, 8, ["class"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3))
      ])
    ]),
    _hoisted_4,
    (__props.data.headingDetails && __props.data.id === idItemExpland.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.headingDetails, (item) => {
            return (_openBlock(), _createBlock(_component_ManageTemplateCatergoryItem, {
              key: item.id,
              data: item,
              "no-index": true
            }, null, 8, ["data"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})